import {
  View,
  Text,
  ScrollView,
  Dimensions,
  StyleSheet,
  TouchableOpacity,
  RefreshControl,
} from "react-native";
import React, { useState, useEffect } from "react";
//import MyImageBackground from "../../components/custom/MyImageBackground";
//import Header from "../../components/Header";
import { shadowSm } from "../../colors";
import { AntDesign } from "@expo/vector-icons";
import MyText from "../../components/custom/MyText";
import { primary, gray } from "../../colors";

// import FaqIcon from "../../assets/icons/FaqIcon";
import MyFaq from "../../components/home/MyFaq";
import FAQ from "../../api/get/FAQ";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../functions/translate";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
//import getFaq from "../../api/get/getFaq";
//import { setOffline } from "../redux/main/mainAction";

export default function FaqScreen(props) {
  const navigation = useNavigation();
  const [list, setList] = useState([]);
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  useEffect(() => {
    FAQ()
      .then((response) => {
        
        if (response.data.status === 200) {
          setList([...response.data.data]);
        } else {
          setList([]);
        }
      })
      .catch((error) => {
        dispatch(setOffline());
      });
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        refreshControl={<RefreshControl refreshing={false} />}
        showsVerticalScrollIndicator={false}
        style={{
          marginTop: -20,
          marginBottom: 20,
          flex: 1,
        }}
      >
        <View
          style={{
            width: Dimensions.get("window").width,
            paddingTop: 45,
            alignItems: "center",
            flex: 1,
          }}
        >
          <View style={styles.container}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              {/* <TouchableOpacity
                onPress={() => navigation.goBack()}
                style={{ alignItems: "flex-start" }}
              >
                <AntDesign name="arrowright" size={24} color={gray} />
              </TouchableOpacity> */}

              <View
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <View style={{ marginHorizontal: 10 }}>
                  {/* <FaqIcon source={logo} width={40} height={40} /> */}
                </View>
                <MyText style={{ fontSize: 16, color: primary }}>
                  {translate("common questions")}
                </MyText>
              </View>

              <View style={{ flex: 1 }}></View>
            </View>
          </View>
          {list.map((item) => (
            <MyFaq
              key={item.id}
              question={main.rtl ? item.questionFa : item.questionEn}
            >
              <Text style={{ fontFamily: "main" }}>
                {main.rtl
                  ? item.answerFa.split("\\n").map((line) => line + "\n")
                  : item.answerEn.split("\\n").map((line) => line + "\n")}
              </Text>
            </MyFaq>
          ))}

          <View></View>
          <View style={{ height: 100 }}></View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: "90%",
    ...shadowSm,
    padding: 15,
    alignItems: "center",
  },
  profileImagePlace: {
    width: 100,
    height: 100,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: primary,
    overflow: "hidden",
  },
});
